import {
  asCurrency,
  asCurrencyWithCents,
  asCurrencyWithDigits,
  asQuantity,
} from '../utils/formatters';

const COMMON_CAPEX_METRICS_BY_NAME = {
  name: {
    displayString: 'Name',
    accessor: 'name',
  },
  quantity: {
    displayString: 'Quantity',
    accessor: 'quantity',
    format: asQuantity,
  },
  purchaseYear: {
    displayString: 'Purchase Year',
    accessor: 'displayPurchaseYear',
  },
};

export const CAPEX_BY_CROP_METRICS = [
  COMMON_CAPEX_METRICS_BY_NAME.name,
  COMMON_CAPEX_METRICS_BY_NAME.purchaseYear,
  {
    displayString: 'Unit cost',
    accessor: 'unitCost',
    parameters: ['applyBuffer', 'applyMargin', 'applySubsidy'],
    format: asCurrency,
  },
  COMMON_CAPEX_METRICS_BY_NAME.quantity,
  {
    displayString: 'Prorated cost',
    accessor: 'proratedCost',
    format: asCurrency,
  },
  {
    displayString: 'Total cost',
    accessor: 'totalCost',
    parameters: ['applyBuffer', 'applyMargin', 'applySubsidy'],
    format: asCurrency,
  },
];

// Only show prorated cost for by crop metrics
export const CAPEX_METRICS = CAPEX_BY_CROP_METRICS.filter(
  ({ accessor }) => accessor !== 'proratedCost',
);

export const CAPEX_BASIS_METRICS = [
  COMMON_CAPEX_METRICS_BY_NAME.name,
  COMMON_CAPEX_METRICS_BY_NAME.purchaseYear,
  {
    displayString: 'Base unit cost',
    accessor: 'baseUnitCost',
    format: asCurrency,
  },
  COMMON_CAPEX_METRICS_BY_NAME.quantity,
  {
    displayString: 'Total base cost',
    accessor: 'baseTotalCost',
    format: asCurrency,
  },
  {
    displayString: 'Total buffered cost',
    accessor: 'bufferedTotalCost',
    format: asCurrency,
  },
  {
    displayString: 'Total quoted cost',
    accessor: 'quotedTotalCost',
    format: asCurrency,
  },
];

const GENETIC_STOCK_QUANTITY_METRICS = [
  {
    displayString: 'Initial quantity',
    accessor: 'treeCount',
    format: asQuantity,
  },
  {
    displayString: 'Replant quantity',
    accessor: 'replantedTreeCount',
    format: asQuantity,
  },
];

export const getCapexGeneticStockMetrics = (shouldShowSubsidy) => [
  { displayString: 'Crop', accessor: 'name' },
  {
    displayString: 'Unit cost',
    accessor: 'unitCost',
    parameters: ['applyBuffer', 'applyMargin', 'applySubsidy'],
    format: asCurrencyWithCents,
  },
  ...(shouldShowSubsidy
    ? [
        {
          displayString: 'Subsidy/stem',
          accessor: ({ unitCostBeforeSubsidy, unitCost }) =>
            unitCostBeforeSubsidy - unitCost,
          format: asCurrencyWithDigits(2, 4),
          hideIfAllMatchFn: (value) => value === 0,
        },
      ]
    : []),
  ...GENETIC_STOCK_QUANTITY_METRICS,
  {
    displayString: 'Total cost',
    accessor: 'totalGeneticsCost',
    format: asCurrency,
  },
];

export const CAPEX_GENETICS_BASIS_METRICS = [
  { displayString: 'Crop', accessor: 'name' },
  {
    displayString: 'Base unit cost',
    accessor: 'baseUnitCost',
    format: asCurrencyWithCents,
  },
  ...GENETIC_STOCK_QUANTITY_METRICS,
  {
    displayString: 'Total base cost',
    accessor: ({ baseUnitCost, treeCount, replantedTreeCount }) =>
      baseUnitCost * (treeCount + replantedTreeCount),
    format: asCurrency,
  },
  {
    displayString: 'Total buffered cost',
    accessor: ({ bufferedUnitCost, treeCount, replantedTreeCount }) =>
      bufferedUnitCost * (treeCount + replantedTreeCount),
    format: asCurrency,
  },
  {
    displayString: 'Total quoted cost',
    accessor: ({ quotedUnitCost, treeCount, replantedTreeCount }) =>
      quotedUnitCost * (treeCount + replantedTreeCount),
    format: asCurrency,
  },
];
